export default function formatFactor(factor: number): string {
	return String(Number(factor.toFixed(10)));
}
